// Shared by the app (My Outreach, Pipeline goal) and the MCP my_performance tool. CommonJS, no imports.
const OUTREACH_KINDS = [
  { key: 'call', label: 'Calls' },
  { key: 'text', label: 'Texts' },
  { key: 'email', label: 'Emails' },
  { key: 'appointment', label: 'Appointments set' },
];
const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
const periodStarts = (now = new Date()) => {
  const today = startOfDay(now);
  const week = new Date(today); week.setDate(today.getDate() - ((today.getDay() + 6) % 7)); // Monday
  const month = new Date(now.getFullYear(), now.getMonth(), 1);
  return { today, week, month };
};
// { call: { today, week, month }, text: {...}, ... }
const tallyOutreach = (entries, now = new Date()) => {
  const p = periodStarts(now);
  const out = Object.fromEntries(OUTREACH_KINDS.map((k) => [k.key, { today: 0, week: 0, month: 0 }]));
  Object.values(entries || {}).forEach((e) => {
    const t = out[e && e.kind]; if (!t) return;
    const at = new Date(e.at); if (Number.isNaN(at.getTime())) return;
    if (at >= p.today) t.today += 1;
    if (at >= p.week) t.week += 1;
    if (at >= p.month) t.month += 1;
  });
  return out;
};

// Pipeline goal: system/pipelineGoal { default, perAgent: { uid: n } }; code default 20.
const DEFAULT_PIPELINE_GOAL = 20;
const INACTIVE = /closed|converted|dead|lost|archived|withdrawn|cancel/i;
const rolesOf = (r) => { const t = Array.isArray(r && r.pipelineTypes) ? r.pipelineTypes : Object.keys((r && r.pipelineTypes) || {}); return t.length ? t : [r && r.kind === 'buyer' ? 'Buyer' : 'Seller']; };
const openRoles = (r) => { const done = { ...(r.convertedTransactions || {}) }; if (r.convertedTransactionId && !done.Seller && r.kind !== 'buyer') done.Seller = true; return rolesOf(r).filter((t) => !done[t]); };
// Active = not a sample, still has a role without a transaction, and not closed/converted/dead.
const isActivePipeline = (r) => !!r && !r.sample && openRoles(r).length > 0 && !INACTIVE.test(`${r.pipelineStatus || ''} ${/converted/i.test(r.status || '') ? '' : (r.status || '')}`);
const goalFor = (cfg, uid) => {
  const own = Number(cfg && cfg.perAgent && cfg.perAgent[uid]);
  if (own > 0) return own;
  const d = Number(cfg && cfg.default);
  return d > 0 ? d : DEFAULT_PIPELINE_GOAL;
};

module.exports = { OUTREACH_KINDS, periodStarts, tallyOutreach, DEFAULT_PIPELINE_GOAL, rolesOf, openRoles, isActivePipeline, goalFor };
